import instrukta from '../../assets/images/instruckta.svg';
import icon1 from '../../assets/images/icon1.webp';
import icon2 from '../../assets/images/icon2.webp';
import icon3 from '../../assets/images/icon3.webp';
import icon4 from '../../assets/images/icon4.webp';
import icon5 from '../../assets/images/icon5.webp';

import './splashScreen.css';

export default function SplashScreen() {
    return (
        <div id="splashScreen">
            <p id="welcomeText">welcome</p>
            <p id="toTheText">to the</p>
            <p id="quizText">Quiz</p>
            <p id="splashScreenText">
                Answer as many questions as you can – Good Luck!!!{' '}
            </p>

            <img id="instruktaImg" src={instrukta} alt="instruckta" />
            <img id="icon1" src={icon1} alt="decor" />
            <img id="icon2" src={icon2} alt="decor" />
            <img id="icon3" src={icon3} alt="decor" />
            <img id="icon4" src={icon4} alt="decor" />
            <img id="icon5" src={icon5} alt="decor" />
        </div>
    );
}
